module.exports = __webpack_public_path__ + "assets/images/2ce4ab7cbea5a9627d9e5cf2934b75ac.png";